// Setup › Workforce › Budgets (`/c/{slug}/setup/budgets`, `…/{id}`) and Skill packs
// (`/c/{slug}/setup/skill-packs`, `…/{id}`): UX pass 1.1 (2026-10-27) moved both from the
// Workforce sidebar to Setup, where configuration lives. Managers only (the Setup gate). The old
// `/agents/budgets…` URLs redirect here; `/agents/skills…` redirects a manager here and stays a
// member's read-only door (routes/c.$slug.agents.tsx).
import { createRoute, redirect } from "@tanstack/react-router";
import { AgentsDoc } from "../features/agents/agents-ux";
import { BudgetDetailScreen, BudgetsScreen } from "../features/agents/budgets-screen";
import { SkillPackScreen, SkillPacksScreen } from "../features/agents/skill-packs-screen";
import { useCompany } from "../features/use-feature";
import { validateFocusSearch } from "../focus/focus";
import { setupRoute } from "./c.$slug.setup";

const ID = /^[0-9a-f-]{36}$/i;

export const setupBudgetsRoute = createRoute({
  getParentRoute: () => setupRoute,
  path: "budgets",
  validateSearch: validateFocusSearch,
  component: function SetupBudgets() {
    const { api } = setupBudgetsRoute.useRouteContext();
    return (
      <AgentsDoc>
        <BudgetsScreen api={api} company={useCompany()} />
      </AgentsDoc>
    );
  },
});

export const setupBudgetRoute = createRoute({
  getParentRoute: () => setupRoute,
  path: "budgets/$id",
  validateSearch: validateFocusSearch,
  beforeLoad: ({ params }) => {
    if (!ID.test(params.id))
      throw redirect({ to: "/c/$slug/setup/budgets", params, replace: true });
  },
  component: function SetupBudget() {
    const { api } = setupBudgetRoute.useRouteContext();
    const { id } = setupBudgetRoute.useParams();
    return (
      <AgentsDoc>
        <BudgetDetailScreen api={api} company={useCompany()} id={id} />
      </AgentsDoc>
    );
  },
});

export const setupSkillPacksRoute = createRoute({
  getParentRoute: () => setupRoute,
  path: "skill-packs",
  validateSearch: validateFocusSearch,
  component: function SetupSkillPacks() {
    const { api } = setupSkillPacksRoute.useRouteContext();
    return (
      <AgentsDoc>
        <SkillPacksScreen api={api} company={useCompany()} />
      </AgentsDoc>
    );
  },
});

export const setupSkillPackRoute = createRoute({
  getParentRoute: () => setupRoute,
  path: "skill-packs/$id",
  validateSearch: validateFocusSearch,
  component: function SetupSkillPack() {
    const { api } = setupSkillPackRoute.useRouteContext();
    const { id } = setupSkillPackRoute.useParams();
    return (
      <AgentsDoc>
        <SkillPackScreen api={api} company={useCompany()} id={id} />
      </AgentsDoc>
    );
  },
});

export const setupWorkforceRoutes = [
  setupBudgetsRoute,
  setupBudgetRoute,
  setupSkillPacksRoute,
  setupSkillPackRoute,
] as const;
